import XLogo from './XLogo';

export default XLogo;
